var buttonTypes = /* @__PURE__ */ ((buttonTypes2) => {
  buttonTypes2["default"] = "default";
  buttonTypes2["negative"] = "negative";
  return buttonTypes2;
})(buttonTypes || {});
export {
  buttonTypes
};
//# sourceMappingURL=IconButton.types.js.map
